import React, { useState } from "react";
import { animated } from "react-spring";
import { Spring } from "react-spring/renderprops";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

function DropdownMenu(props) {
  let closedStyle = {
    height: 0,
  };

  let openStyle = {
    height: "auto",
  };
  let history = useHistory();

  // state used when trying to let all menu open
  //let [open, setOpen] =useState(props.active);
  let [currentLocation, setCurrentLocation] = useState("/");

  const handleMenuDropDownClick = (e) => {
    props.handleClick();
    //setOpen(!open);
  };
  const handleDropdownClick = (link, parentLink) => {
    if (currentLocation !== parentLink) {
      history.push(parentLink);
      setCurrentLocation(parentLink);
      window.location = parentLink + link;
    } else {
      history.push(parentLink);
      window.location = parentLink + link;
    }
  };

  let menu = props.menu;
  let subMenus, subMenuContent, menuContent;

  if (menu.submenus.length) {
    subMenus = menu.submenus.map((submenu, index) => {
      return (
        <li key={index}>
          <Link
            onClick={() => handleDropdownClick(submenu.link, menu.link)}
            // to={menu.link + submenu.link || "/"}
          >
            {" "}
            {submenu.title}
            {submenu.badge ? (
              <span className={"badge badge-pill " + submenu.badge.class}>
                {" "}
                {submenu.badge.text}{" "}
              </span>
            ) : (
              ""
            )}
          </Link>
        </li>
      );
    });
    subMenuContent = (
      <Spring from={openStyle} to={props.active ? openStyle : closedStyle}>
        {(props) => (
          <animated.div className="sidebar-submenu" style={props}>
            <ul> {subMenus} </ul>
          </animated.div>
        )}
      </Spring>
    );
  }
  const linkMenu = (
    <Link
      // to="/"
      onClick={(e) => {
        handleMenuDropDownClick(e);
      }}
    >
      <i className={menu.icon}></i>
      <span className="menu-text">{menu.title}</span>
      {menu.badge ? (
        <span className={"badge badge-pill " + menu.badge.class}>
          {" "}
          {menu.badge.text}{" "}
        </span>
      ) : (
        ""
      )}
    </Link>
  );
  menuContent = (
    <>
      {" "}
      {linkMenu} {subMenuContent}{" "}
    </>
  );

  return (
    <li
      className={props.active ? "sidebar-dropdown active" : "sidebar-dropdown"}
    >
      {menuContent}
    </li>
  );
}

export default DropdownMenu;
